export default __webpack_public_path__ + "static/media/Open_Keyboard.8b0889c5.svg";